// ─── ENV variable validation ─────────────────
// Runs at app startup. Clear console output so
// developers know exactly what's missing/optional.
//
// Reads utils/clientEnv.js rather than process.env directly. A computed
// process.env[key] lookup makes webpack inline the whole process.env object,
// which is exactly how the Razorpay and Sentinel secrets ended up in the public
// bundle. Every access must stay static — see the comment in clientEnv.js.
//
// There is deliberately NO AI key here. Inference runs server-side behind the
// Cloud Functions proxy (services/aiProvider.js); the browser never holds a
// model credential. Do not re-add one.

import { CLIENT_ENV, isConfigured } from "./clientEnv";

const REQUIRED_VARS = [
  { key: "FIREBASE_API_KEY",     desc: "Firebase API Key" },
  { key: "FIREBASE_PROJECT_ID",  desc: "Firebase Project ID" },
  { key: "FIREBASE_AUTH_DOMAIN", desc: "Firebase Auth Domain" },
];

const OPTIONAL_VARS = [
  { key: "WEATHER_CF_URL",     desc: "Weather Cloud Function URL — weather widget uses fallback" },
  { key: "RECAPTCHA_SITE_KEY", desc: "reCAPTCHA site key — App Check cannot be enabled without it" },
  { key: "GOOGLE_MAPS_KEY",    desc: "Google Maps key — map views degrade to a static list" },
];

export function validateEnv() {
  const missing = REQUIRED_VARS
    .filter(({ key }) => !isConfigured(CLIENT_ENV[key]))
    .map(({ key, desc }) => `❌ ${key} — ${desc}`);

  const warnings = OPTIONAL_VARS
    .filter(({ key }) => !isConfigured(CLIENT_ENV[key]))
    .map(({ key, desc }) => `⚠️  ${key} — ${desc}`);

  if (warnings.length > 0 && CLIENT_ENV.NODE_ENV === "development") {
    console.warn(
      "[FassalkartAI] Optional ENV vars not set:\n" + warnings.join("\n")
    );
  }

  if (missing.length > 0) {
    console.error(
      "[FassalkartAI] MISSING required ENV vars:\n" +
      missing.join("\n") +
      "\n\n→ Add these to your .env file and restart."
    );
  }

  return { isReady: missing.length === 0, missing, warnings };
}

export default validateEnv;
